import {useAntdTable} from "../../../../__snowpack__/pkg/ahooks.js";
import {useRef} from "../../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import {isArray} from "../../../../__snowpack__/pkg/lodash.js";
const useTable = (service, options) => {
  const {formatMessage} = useIntl();
  const {paged = true, form} = options ?? {};
  const ref = useRef({});
  const _service = async (...args) => {
    const [params, formValues] = args;
    const {current, pageSize, filter, sorter} = params;
    const pageInfo = {
      page: current - 1,
      size: pageSize,
      filter,
      sorter
    };
    try {
      if (!paged) {
        const {noPagedData, lastCurrentPage, lastPageSize} = ref.current;
        let data2 = noPagedData;
        if (!data2 || lastCurrentPage === current && lastPageSize === pageSize) {
          const values = form?.getFieldsValue(true) ?? {};
          data2 = await service(values) ?? [];
          ref.current.noPagedData = data2;
        }
        ref.current.lastCurrentPage = current;
        ref.current.lastPageSize = pageSize;
        let list = data2?.slice(pageSize * (current - 1), pageSize * current) ?? [];
        if (list.length === 0 && current > 1) {
          list = data2?.slice(pageSize * (current - 2), pageSize * current) ?? [];
          ref.current.lastCurrentPage = current - 1;
        }
        return {
          data: data2,
          list,
          total: data2?.length ?? 0
        };
      }
      const data = await service({...pageInfo, ...formValues}, {...pageInfo}, {...formValues});
      return {
        ...data,
        list: isArray(data) ? data : data?.content ?? [],
        total: (data?.totalElements || data?.total) ?? 0
      };
    } catch (error) {
      console.error(error);
      return {list: [], total: 0};
    }
  };
  const _options = {
    ...options,
    onBefore: (params) => {
      options?.onBefore?.(transformParams(params, paged));
    },
    onSuccess: (data, params) => {
      options?.onSuccess?.(data, transformParams(params, paged));
    },
    onError: (e, params) => {
      options?.onError?.(e, transformParams(params, paged));
    },
    onFinally: (params, data, e) => {
      options?.onFinally?.(transformParams(params, paged), data, e);
    }
  };
  const result = useAntdTable(_service, _options);
  result.search.loading = result.loading;
  result.pagination.showTotal = (total) => formatMessage({id: "globalsTotalPage"}, {total});
  result.tableProps.pagination.showTotal = (total) => formatMessage({id: "globalsTotalPage"}, {total});
  return result;
};
export default useTable;
const transformParams = (params, paged) => {
  const {current, pageSize, filter, sorter} = params?.[0] ?? {};
  const pageInfo = {
    page: current - 1,
    size: pageSize,
    filter,
    sorter
  };
  return paged ? {...pageInfo, ...params?.[2]?.allFormData} : {...params?.[2]?.allFormData};
};
